import {connect} from "react-redux";
import {Navigation} from "@reside/ui";
import {RoleNameEnum} from "../../utils/types/common";
import {Link} from "react-router-dom";
import {NavLogo} from "../nav-logo";
import {select, AppState} from "../../store";
import {Tabs} from "./atoms/Tabs";
import {UserProfileAsLink} from "./atoms/UserProfileAsLink";
import {SignOut} from "./atoms/SignOut";
import {UserProfileAsDropdownMenu} from "./atoms/UserProfileAsDropdownMenu";
import {AnnounceKitWidget} from "../announcekit-widget";
import {StonlyButton} from "../../atoms/stonly/StonlyButton";
import {Icon, MediaWrapper} from "./styles";
import {AdminNavigationHeaderProps} from "./types";
import {AdministrationMenu} from "./atoms/AdministrationMenu";
import {FacilityFilter} from "./FacilityFilter";

export const Renderer = ({
  user,
  displayReportingTab,
  firstFacility,
}: AdminNavigationHeaderProps) => {
  const isClerk = user.role.name === RoleNameEnum.CLERK;
  const isOrganizationItAdmin =
    user.role.name === RoleNameEnum.ORGANIZATION_IT_ADMIN;
  const organizationId = user.organization?.id;

  return (
    <Navigation>
      <Link
        to={
          isOrganizationItAdmin && organizationId
            ? `/admin/organizations/${organizationId}/sso-configuration`
            : "/admin/dashboard"
        }
      >
        <NavLogo className="image-reside-logo-minimal" />
      </Link>
      {!isOrganizationItAdmin && <FacilityFilter />}
      <Tabs
        role={user.role.name as RoleNameEnum}
        displayReportingTab={displayReportingTab}
        organizationId={organizationId}
        organizationName={user.organization?.name}
      />
      <Icon />
      {!isClerk && !isOrganizationItAdmin && (
        <AdministrationMenu
          role={user.role.name as RoleNameEnum}
          firstFacilityId={firstFacility?.id}
        />
      )}
      <AnnounceKitWidget />
      <StonlyButton />
      <MediaWrapper>
        <UserProfileAsLink user={user} />
        <SignOut />
        <UserProfileAsDropdownMenu user={user} />
      </MediaWrapper>
    </Navigation>
  );
};

const mapStateToProps = (state: AppState) => ({
  user: select.adminSession.user(state),
  displayReportingTab: select.adminSession.hasReportingAccess(state),
  firstFacility: select.adminSession.firstFacility(state),
});

export const AdminNavigationHeader = connect(mapStateToProps)(Renderer);
